// TODO: Import css explicitly somehow.
import React, { useState, useEffect, useRef } from 'react';

function getSlide(component: React.ReactNode, key: number, transform: string, onTransitionEnd?: () => void) : React.JSX.Element{
    return (
        <div key={key} className="slide" style={{ 'transform': transform }} onTransitionEnd={onTransitionEnd}>
            {component}
        </div>
    )
}

// Shows a component associated with an item. The old item slides out and the new item slides in, and the direction
// depends on the comparison between them.
function Slider<ItemType>(options: { item: ItemType, getComponentFromItem: (i: ItemType) => React.ReactNode, compareItems: (item1: ItemType, item2: ItemType) => number }) {
    enum State {
        ARRIVED = 0,
        STARTING = 1,
        MOVING = 2,
    }

    enum Direction {
        LEFT = 0,
        RIGHT = 1,
    }

    const [destination, setDestination] = useState<ItemType>()
    const [origin, setOrigin] = useState<ItemType>()
    const [state, setState] = useState(State.ARRIVED)
    const [direction, setDirection] = useState<Direction>() // Doesn't matter when state === ARRIVED.
    const sliderRef = useRef<HTMLDivElement>(null)
    const [key, setKey] = useState(0)

    useEffect(() => { if (state === State.STARTING) setState(State.MOVING) }, [state])

    if (options.item === destination) {
        const slideWidth = sliderRef.current ? sliderRef.current.clientWidth : null
        const shouldTranslate = state === State.STARTING && direction === Direction.RIGHT || state === State.MOVING && direction === Direction.LEFT
        const transform = shouldTranslate ? `translateX(-${slideWidth}px)` : 'translateX(0px)'
        const onTransitionEnd = state === State.MOVING ? () => { setState(State.ARRIVED); setKey(key + 1) } : undefined
        const destinationComponent = options.getComponentFromItem(options.item)
        const destinationSlide = getSlide(destinationComponent, 1, transform, onTransitionEnd)
        let slides: React.JSX.Element[]
        if (state === State.ARRIVED) {
            slides = [destinationSlide]
        } else {
            const originComponent = options.getComponentFromItem(origin!)
            const originSlide = getSlide(originComponent, 0, transform)
            slides = direction === Direction.LEFT ? [originSlide, destinationSlide] : [destinationSlide, originSlide]
        }
        const sliderDiv = <div key={key} ref={sliderRef} className='slider'>{slides}</div>
        return sliderDiv
    }
    setOrigin(destination)
    setDestination(options.item)
    if (destination === undefined) {
        setState(State.ARRIVED)
    } else {
        const comp = options.compareItems(destination, options.item)
        if (comp === 0) {
            setState(State.ARRIVED)
        } else if (comp < 0) {
            setState(State.STARTING)
            setDirection(Direction.LEFT)
        } else {
            setState(State.STARTING)
            setDirection(Direction.RIGHT)
        }
    }
    setKey(key + 1)
    return null
}

export default Slider
